import { useMemo } from "react"

const useTrimText = (text: string, max: number): string => {
  const newText = useMemo(() => {
    // If text is within our max length return text as is
    if ((text?.length ?? 0) < max) {
      return text
    }

    // Slice text to max length and add trailing ...
    return text?.slice(0, max).concat("...")
  }, [max, text])

  return newText ?? ""
}

export default useTrimText
